var _defs, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,2H2A2,2,0,0,0,0,4V6.5A.5.5,0,0,0,.5,7H1V17a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V7h.5a.5.5,0,0,0,.5-.5V4A2,2,0,0,0,18,2Zm0,15a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7H18ZM19,6H1V4A1,1,0,0,1,2,3H18a1,1,0,0,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,11h5a.5.5,0,0,0,0-1h-5a.5.5,0,0,0,0,1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.f1688e771a5bd25fe2e91b8c2f3d835b.svg";
export { ForwardRef as ReactComponent };